@if (effectiveContext(); as ctx) {
  @if (mode() === 'full') {
    <hd-gate-info-full
      [context]="ctx"
      [sectionVariant]="sectionVariant()"
      (collapseRequested)="showSmall()"
    />
  } @else {
    <hd-gate-info-small [context]="ctx" (expandRequested)="showFull()" />
  }
}
